import React, { useState, useMemo, useEffect } from 'react';
import { useTable } from 'react-table';
import './BestVarietiesTable.css';
import CriteriasPanel from '../CriteriasPanel/CriteriasPanel';
import FiltersPanel from '../FiltersPanel/FiltersPanel';
import Slugify from '@js/utils/Slugify';
import { ReactComponent as IconSettings } from '@icons/settings.svg';
import { ReactComponent as IconStat } from '@icons/statistics.svg';
import { ReactComponent as IconEmail } from '@icons/mail.svg';
import { ReactComponent as IconShare } from '@icons/share.svg';
import { ReactComponent as IconMoreSettings } from '@icons/more-settings.svg';
import { useIntl } from 'react-intl';
import fetcher from '@js/api';
import Modal from '@components/Modal/Modal';

const criterias = [
  'Précocité maturité',
  'Vigueur de départ',
  'Indice de masse foliaire',
  'Résistance Mildiou',
  'Tolérance Verticillium',
  'Tolérance Phomopsis',
  "Comportement à l'orobanche",
  'Richesse huile',
  'VRTH'
];

function BestVarietiesTable({ products }) {
  const intl = useIntl();
  const [toggleCriterias, setToggleCriterias] = useState(false);
  const [toggleFilters, setToggleFilters] = useState(false);
  const [copyUrl, setCopyUrl] = useState(false);
  const [activeColumns, setActiveColumns] = useState(criterias);

  const columns = useMemo(() => [
    {
      accessor: 'title',
      Header: 'Variété'
    },
    {
      accessor: 'Précocité maturité',
      Header: 'Précocité maturité'
    },
    {
      accessor: 'Vigueur de départ',
      Header: 'Vigueur de départ'
    },
    {
      accessor: 'Indice de masse foliaire',
      Header: 'Indice de masse foliaire'
    },
    {
      accessor: 'Résistance Mildiou',
      Header: 'Résistance Mildiou'
    },
    {
      accessor: 'Tolérance Verticillium',
      Header: 'Tolérance Verticillium'
    },
    {
      accessor: 'Tolérance Phomopsis',
      Header: 'Tolérance Phomopsis'
    },
    {
      accessor: "Comportement à l'orobanche",
      Header: "Comportement à l'orobranche"
    },
    {
      accessor: 'Tolérance à la verse',
      Header: 'Tolérance à la verse'
    },
    {
      accessor: 'Richesse huile',
      Header: 'Richesse huile'
    },
    {
      accessor: 'VRTH',
      Header: 'VRTH'
    },
  ].filter(({ accessor }) =>
    accessor === 'title' || activeColumns.includes(accessor)),
  [activeColumns]);

  const data = useMemo(() => products, [products]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data
  });


  useEffect(() => {
    if(copyUrl) {
      navigator?.clipboard?.writeText(window.location.href);

      setTimeout(() => {
        setCopyUrl(false)
      }, 2000);
    }
  },[copyUrl])

  const sendTracking = async (type) => {
    await fetcher({
      url: `/open_api/expertsystem/action?type=${type}`,
      method: 'GET',
    });
  }

  useEffect(() => {
    const modal = async () => {
      await Modal();
    }
    modal();
  }, []);

  return (
    <>
      <section className="BestVarietiesTable">
        <div className="BestVarietiesTable-buttons">
          <div className="BestVarietiesTable-buttonsGroup">
            <button
              onClick={() => {
                setToggleFilters(true);
              }}
              className="btn btn--secondary"
              >
                <IconSettings className="w-5 h-5 mr-2 text-gray-900"/> <span>{intl.formatMessage({id : 'FILTER'})}</span>
            </button>
            <button
              onClick={() => {
                setToggleCriterias(true);
              }}
              className="btn btn--secondary"
              >
                <IconMoreSettings className="w-5 h-5 mr-2 text-gray-900"/> <span>{intl.formatMessage({id : 'MORE_SETTINGS'})}</span>
            </button>
            <button type="button" onClick={async () => {
              await sendTracking('print');
              window.print()
            }} className='ml-auto btn btn--secondary'>
              <IconStat className="w-5 h-5 mr-2 text-gray-900"/> <span>{intl.formatMessage({id : 'PRINT'})}</span>
            </button>
            <button type="button" data-micromodal-trigger="modal-copy" className="btn btn--secondary" onClick={async () => {await sendTracking('share')}}>
              <IconShare className="w-5 h-5 mr-2 text-current"/> <span>{intl.formatMessage({id : copyUrl ? 'COPY':'SHARE'})}</span>
            </button>
            <a href={`mailto: ?body=Bonjour,%0D%0AVoici une sélection de produits que j'ai trouvé via LG Seeds.fr.%0D%0A${window.location.href}">${window.location.href}`} onClick={async () => {await sendTracking('mail')}} className='btn btn--secondary'>
              <IconEmail className="w-5 h-5 mr-2 text-gray-900"/> <span>{intl.formatMessage({id : 'SEND_TO_FRIEND'})}</span>
            </a>
          </div>
        </div>
        <div className="BestVarietiesTable-tableContainer">
          <div className="BestVarietiesTable-tableContainerScrollable">
            <table {...getTableProps()}>
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()} key={`headerGroup-${headerGroup.id}`}>
                    {headerGroup.headers.map((column) => (
                      <th key={`column-${Slugify(column.Header)}`}>
                        {column.render('Header')}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, indexRow) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      className={indexRow < 3 ? 'recommended' : ''}
                      key={`key-${row.id}`}>
                        {row.cells.map((cell, index) => {
                          return (
                          <td {...cell.getCellProps()} key={`cell-${index}`} className='font-semibold'>
                            {cell.render('Cell')}
                            {index === 0 && (
                              <a href={products[indexRow].url} target='_blank' rel="noreferrer" className='block font-normal underline'>Voir la fiche produit</a>
                            )}
                          </td>
                        )})}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <FiltersPanel
        toggleFilters={toggleFilters}
        setToggleFilters={setToggleFilters} />
      <CriteriasPanel
        criterias={criterias}
        toggleCriterias={toggleCriterias}
        setToggleCriterias={setToggleCriterias}
        setActiveColumns={setActiveColumns} />
    </>
  )
}

export default BestVarietiesTable;
